<template>
  <div
    :style="{ bottom: upBtn || fullFooter ? '0' : '-' + footerHeight + 'px' }"
    class="footer"
  >
    <b-btn class="toggle-btn" @click="upBtn = !upBtn" v-if="!fullFooter">
      <i v-if="!upBtn" class="fas fa-ellipsis-v fa-lg"></i>
      <i v-else class="fas fa-ellipsis-h fa-lg"></i>
    </b-btn>
    <footer
      :style="{
        background: config.footerBackgroundColor,
        color: config.footerFontColor,
        fontSize: config.footerFontSize,
      }"
    >
      <b-row class="text-center mt-1 pb-2 pt-2">
        <b-col cols="12" md="4" offset-md="2">
          <router-link
            :to="getPath('QueueStatus')"
            @click.native="upBtn = false"
            >{{
              $locales.t("footer.queueStatus", "Podgląd kolejek")
            }}</router-link
          >
        </b-col>
        <b-col cols="12" md="4">
          <router-link
            :to="getPath('Reservation')"
            @click.native="
              upBtn = false;
              toReservation();
            "
            >{{
              $locales.t("footer.reservation", "Umawianie wizyt")
            }}</router-link
          >
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
import { getCompanyNameFromConfig } from "@/utils/appSettings";
export default {
  name: "customFooter",
  data() {
    return {
      fullFooter: true,
      upBtn: false,
      footerHeight: 0,
    };
  },
  watch: {
    baseFontSize: function () {
      this.setFooterSize();
    },
  },
  methods: {
    resizeHandler() {
      this.fullFooter = window.innerWidth > 992;
    },
    toReservation() {
      if (this.$route.name === "Reservation") this.$store.dispatch("setKey");
    },
    setFooterSize() {
      this.footerHeight =
        document.getElementsByTagName("footer")[0].offsetHeight;
    },
    getPath(path) {
      if (getCompanyNameFromConfig()) {
        return "/" + path;
      } else {
        return "/" + this.companyName + "/" + path;
      }
    },
  },
  computed: {
    config: function () {
      return this.$store.getters.layoutConfig;
    },
    companyName: function () {
      return this.$store.getters.getCompanyName;
    },
    baseFontSize: function () {
      return this.$store.getters.getBaseFontSize;
    },
  },
  mounted() {
    var vm = this;
    vm.setFooterSize();
    window.addEventListener("resize", function () {
      vm.resizeHandler();
    });
    setTimeout(() => {
      vm.resizeHandler();
    }, 1000);
  },
};
</script>

<style scoped>
footer {
  bottom: 0;
  font-size: 18px;
  color: white;
  z-index: 10000;
}
footer .footer-content {
  color: inherit;
  margin: auto;
}

footer a {
  color: inherit;
}
footer .footer-content .nav-link {
  color: inherit;
}

footer .footer-content .nav-link.disabled:hover {
  cursor: default;
}
div.footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  transition: all 0.5s;
  overflow: hidden;
}
</style>

